import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    ListarEmailBlacklistController,
    RemoverEmailBlacklistController,
} from "../../../../Controllers/Geral/Triagem/TriagemControllers";
import { IBlacklistEmail } from "../../../../Interfaces/Geral/Triagem";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useEffect, useState } from "react";
import Table from "../../../../Components/Table";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import Swal from "sweetalert2";

export function BlacklistEmail() {
    const [lstEmails, setLstEmails] = useState<Array<IBlacklistEmail>>([]);

    const {
        value: lstEmailBlacklist,
        loading: lstEmailBlacklistLoading,
        execute: ListarEmailsBlacklist,
    } = useAsyncCallback(ListarEmailBlacklistController);

    const updateListEmails = () => {
        ListarEmailsBlacklist().then((res) => {
            setLstEmails(res);
        });
    };

    useEffect(() => {
        updateListEmails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_EMAIL",
            text: `Email${
                (lstEmailBlacklist?.length ?? 0) > 1 ? "s" : ""
            } da Blacklist`,
            formatter: row,
        },
    ];

    function row(cell: any, row: IBlacklistEmail) {
        return (
            <div>
                <div className="card">
                    <div className="card-body row">
                        <div className="col-12 d-flex flex-wrap justify-content-between align-items-center mb-2">
                            <div className="d-flex flex-column">
                                <h4 className="mb-0">{row.DS_EMAIL}</h4>
                            </div>
                            <div>
                                <div
                                    className="dropdown dropdown-inline"
                                    data-toggle="tooltip"
                                    title=""
                                    data-placement="left"
                                    data-original-title="Quick actions"
                                >
                                    <a
                                        href="#/"
                                        className="btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                                        data-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <i className="ki ki-bold-more-hor"></i>
                                    </a>
                                    <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                                        <ul className="navi navi-hover">
                                            <li
                                                className="navi-item"
                                                role="button"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Deseja remover esse email da blacklist?",
                                                        icon: "info",
                                                        buttonsStyling: false,
                                                        confirmButtonText:
                                                            "<i class='la la-check'></i> Sim!",
                                                        showCancelButton: true,
                                                        cancelButtonText:
                                                            "<i class='la la-thumbs-down'></i> Não",
                                                        customClass: {
                                                            confirmButton:
                                                                "btn btn-outline-success",
                                                            cancelButton:
                                                                "btn btn-default",
                                                        },
                                                    }).then((result) => {
                                                        if (
                                                            result.isConfirmed
                                                        ) {
                                                            RemoverEmailBlacklistController(
                                                                row.ID_EMAIL_BLACKLIST
                                                            ).then(
                                                                updateListEmails
                                                            );
                                                        }
                                                    });
                                                }}
                                            >
                                                <span className="navi-link">
                                                    <span className="navi-icon">
                                                        <FontAwesomeIcon
                                                            icon={faUndo}
                                                            className="text-dark"
                                                        />
                                                    </span>
                                                    <span className="navi-text pl-1">
                                                        Remover da Blacklist
                                                    </span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Table
            data={lstEmails}
            keyField="DS_EMAIl"
            columns={columns}
            loading={lstEmailBlacklistLoading}
            noDataIndication={
                <div className="text-muted text-center">
                    Nenhum email na blacklist
                </div>
            }
            bordered={false}
            noHover
        />
    );
}
